import { useMutation } from "react-query";
import getDocument from "@funded-here-interface/common/src/services/getDocument";

const useGetDocument = () => {
  return useMutation(["get-document"], getDocument);
};

export default useGetDocument;
